import React from 'react';
import PropTypes from 'prop-types';
import LoadingCard from 'components/loading/LoadingCard';
import NoResults from 'components/form/styling/NoResults';
import ProductLocalisationShow from './ProductLocalisationShow';
import utils from 'helpers/utils';
import { fetchProductLocalisation } from 'store/actions/product-localisation/fetchProductLocalisation';
import fetchResourceById from 'components/hoc/fetchResourceById';

class ProductLocalisationShowContainer extends React.Component {
    render() {
        const {
            data,
            resourceFetchLoading,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (utils.isEmpty(data)) {
            return <NoResults label='forms.no_results' />;
        }

        return <ProductLocalisationShow
            localisation={ data }
        />;
    }
}

ProductLocalisationShowContainer.propTypes = {
    data: PropTypes.object,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    action: fetchProductLocalisation,
    resource: 'productLocalisation',
};

export default fetchResourceById(fetchValues)(ProductLocalisationShowContainer);



// WEBPACK FOOTER //
// ./src/pages/products/productLocalisation/show/ProductLocalisationShowContainer.js